<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <h1>{{ $t('menu.general-detail') }}</h1>
            <piaf-breadcrumb />
            <div class="separator mb-5" />
        </b-colxx>
    </b-row>

    <b-row class="mb-5">
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row>
                    <b-colxx xxs="12" lg="6" aling="center">
                        <b-form>
                            <b-form-group label-cols="4" horizontal label="아이디">
                                <b-form-input v-model="username" :plaintext="true"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="4" horizontal label="이름">
                                <b-form-input v-model="fullName" :plaintext="true"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="4" horizontal label="휴대폰">
                                <b-form-input v-model="phoneNumber" :plaintext="true"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="4" horizontal label="이메일">
                                <b-form-input v-model="email" :plaintext="true"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="4" horizontal label="사용자 약관 동의 항목">
                                <!-- <b-form-group label-cols="4" horizontal label="이용약관 동의">
                                    <p style="padding-top:calc(.375rem + 1px);">
                                        {{ consents.includes('ConsentToTermsOfUse') === true ? '동의' : '거부'}}
                                    </p>
                                </b-form-group> -->
                                <!-- <b-form-group label-cols="4" horizontal label="개인정보 수집 및 이용에 대한 동의">
                                    <p style="padding-top:calc(.375rem + 1px);">
                                        {{ consents.includes('ConsentToPrivacyPolicy') === true ? '동의' : '거부'}}
                                    </p>
                                </b-form-group> -->
                                <!-- <b-form-group label-cols="4" horizontal label="개인정보 3자제공 동의">
                                    <p style="padding-top:calc(.375rem + 1px);">
                                        {{ consents.includes('ConsentToDisclosureTo3rdParty') === true ? '동의' : '거부'}}
                                    </p>
                                </b-form-group> -->
                                <b-form-group label-cols="8" horizontal :label="`이메일 마케팅 수신 동의 : ${consents.includes('ConsentToEmailMarketing') === true ? '동의' : '거부'}`">
<!--                                    <p style="padding-top:calc(.375rem + 1px);">-->
<!--                                        {{ }}-->
<!--                                    </p>-->
                                </b-form-group>
                                <b-form-group label-cols="8" horizontal :label="`SMS 마케팅 수신 동의 : ${consents.includes('ConsentToSmsMarketing') === true ? '동의' : '거부'}`">
<!--                                    <p style="padding-top:calc(.375rem + 1px);">-->
<!--                                        {{ }}-->
<!--                                    </p>-->
                                </b-form-group>
                            </b-form-group>
                            <b-form-group label-cols="4" horizontal label="개인정보 유효기간">
                                <b-form-input v-model="userDataRetentionPeriod" :plaintext="true"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-colxx>
                </b-row>
            </b-card>
            <b-button variant="outline-primary" class="mt-0" @click.prevent="goBack">뒤로</b-button>
        </b-colxx>

    </b-row>

</div>
</template>

<script>
import api from '../../constants/api'
import {
    mapGetters,
    mapActions
} from "vuex";

export default {

    data() {
        return {
            username: '',
            fullName: '',
            phoneNumber: '',
            email: '',
            consents: [],
            consentDate: '',
            registeredDate: '',
            userDataRetentionPeriod: '',
        }
    },
    mounted() {
        this.generalDetail();
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    methods: {
        goBack(){
            this.$router.back();
        },
        generalDetail() {
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.generalDetail + '?username=' + this.$route.params.id)

            this.$http.get(reqURL, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.username = res.data.data.username
                    this.fullName = res.data.data.fullName
                    this.phoneNumber = res.data.data.phoneNumber
                    this.email = res.data.data.email
                    this.consents = res.data.data.consents
                    this.consentDate = res.data.data.consentDate
                    this.registeredDate = res.data.data.registeredDate
                    this.userDataRetentionPeriod = res.data.data.userDataRetentionPeriod === 0 ? '탈퇴시' : res.data.data.userDataRetentionPeriod
                } else {
                    throw 400
                }
            }).catch(err => {})
        }
    }
}
</script>

<style>
.form-control-plaintext{
  font-size: 14.4px !important;
}
</style>
